import script from "./join.vue?vue&type=script&setup=true&lang=js"
export * from "./join.vue?vue&type=script&setup=true&lang=js"

import "./join.css?vue&type=style&index=0&id=15526bbb&scoped=true&lang=css"
import "./join.vue?vue&type=style&index=1&id=15526bbb&lang=css"

import exportComponent from "D:\\work\\gw-sh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15526bbb"]])

export default __exports__